import React from 'react';
import { useNavigate } from 'react-router-dom';

import { IMAGES } from '../utils/images';
import { MUSIC_CREDITS, type MusicCredit } from '../utils/musicCreditsData';
import tinySharkLogoWhite from '../assets/TinySharkLogoWhite.svg';
import lucasMotsLogo from '../assets/lucas_mots_logo.png';

import './profile.css';
import './credits.css';

function MusicCreditCard({ credit }: { credit: MusicCredit }): React.ReactElement {
    return (
        <div className="credits_ack_card">
            <p className="credits_ack_line">
                <cite className="credits_ack_track">{credit.trackTitle}</cite> by {credit.artist}
                {' · '}
                <a
                    href={credit.primaryLink.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="credits_ack_link"
                >
                    {credit.primaryLink.label}
                </a>
            </p>
            <p className="credits_ack_line">
                Royalty Free Music by{' '}
                <a
                    href={credit.royaltyFreeLink.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="credits_ack_link"
                >
                    {credit.royaltyFreeLink.label}
                </a>
            </p>
            <p className="credits_ack_line">{credit.license.summary}</p>
            <p className="credits_ack_line">
                <a
                    href={credit.license.deedHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="credits_ack_link"
                >
                    {credit.license.deedLabel}
                </a>
            </p>
        </div>
    );
}

const CreditsPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div
            className="profile_page_container"
            style={{ backgroundImage: `url(${IMAGES.backgrounds.room})` }}
        >
            <header className="profile_top_bar credits_top_bar">
                <button type="button" className="button_std credits_top_bar_back" onClick={() => navigate('/home')}>
                    Back
                </button>
                <h1 className="credits_top_title">Credits</h1>
                <img src={IMAGES.logo} alt="" className="profile_top_bar_logo credits_top_bar_logo" />
            </header>
            <div className="credits_main" aria-label="Credits body">
                <div className="credits_scroll">
                    <p className="credits_message">
                        Thank you for playing Monsters of the Sea!
                    </p>

                    <div className="credits_tile_grid credits_logo_grid" aria-label="Logos">
                        <div className="credits_logo_cell">
                            <div className="credits_logo_stack">
                                <img
                                    src={lucasMotsLogo}
                                    alt=""
                                    className="credits_shark_logo"
                                />
                                <p className="credits_logo_caption">Art and game idea by Lucas Klopfenstein</p>
                            </div>
                        </div>
                        <div className="credits_logo_cell">
                            <img
                                src={tinySharkLogoWhite}
                                alt=""
                                className="credits_shark_logo"
                            />
                        </div>
                    </div>

                    <h2 className="credits_section_title">Music</h2>
                    <div className="credits_tile_grid" aria-label="Music credits">
                        {MUSIC_CREDITS.map((credit) => (
                            <MusicCreditCard key={credit.trackTitle} credit={credit} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreditsPage;
